export const ORBIT_LEVELS = { 1: "Admin", 2: "Direction", 3: "Management", 4: "Magasin" };

export const ORBIT_ROLES = [
  { key: "dirigeant", label: "Dirigeant", level: 1, role: "admin" },
  { key: "administrateur", label: "Administrateur", level: 1, role: "admin" },
  { key: "directeur_service", label: "Directeur service", level: 2, role: "director" },
  { key: "responsable_secteur", label: "Responsable secteur", level: 3, role: "manager" },
  { key: "support", label: "Support", level: 3, role: "support" },
  { key: "itinerant", label: "Itinérant", level: 3, role: "manager" },
  { key: "responsable_magasin", label: "Responsable magasin", level: 4, role: "corner" },
  { key: "collaborateur_magasin", label: "Collaborateur magasin", level: 4, role: "corner" },
  { key: "magasin", label: "Magasin", level: 4, role: "corner" },
];

export const LEVEL_STYLE = { 1: "bg-rose-100 text-rose-700", 2: "bg-indigo-100 text-indigo-700", 3: "bg-blue-100 text-blue-700", 4: "bg-emerald-100 text-emerald-700" };

export const usesOrbitRoles = (tenant) => (tenant?.slug || tenant) !== "wasabi";
export const orbitRole = (key) => ORBIT_ROLES.find(r => r.key === key);
export const orbitRoleLabel = (u) => orbitRole(u?.orbit_role)?.label;
export const isStoreLevel = (u) => u?.orbit_level === 4 || u?.is_corner || u?.role === "corner";

export const groupedRoleOptions = () => Object.entries(ORBIT_LEVELS).map(([lvl, name]) => ({
  level: Number(lvl), label: `Niveau ${lvl} · ${name}`, roles: ORBIT_ROLES.filter(r => r.level === Number(lvl)),
}));
